import React from 'react';

const AcademicPage_2_ISMAR = () => {
  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh', fontFamily: 'Georgia, serif' }}>
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* 标题 */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '36px', 
            fontWeight: 'normal', 
            color: '#333', 
            lineHeight: '1.2',
            marginBottom: '20px'
          }}>
            Exploring the Feasibility of Gaze-Based Navigation Across Path Types
          </h1>
          
          {/* 作者列表 */}
          <div style={{ fontSize: '16px', color: '#666', lineHeight: '1.5' }}>
            <span style={{ color: '#4A90E2', fontWeight: 'bold' }}>Yichuan Zhang</span>, Liangyuting Zhang, Xuning Hu, Yong Yue, and Hai-Ning Liang
          </div>
        </div>

        {/* 摘要部分 */}
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: 'normal', 
            color: '#333', 
            textAlign: 'center',
            marginBottom: '30px',
            fontStyle: 'italic'
          }}>
            Abstract
          </h2>
          
          <div style={{ 
            fontSize: '16px', 
            color: '#444', 
            lineHeight: '1.6', 
            textAlign: 'justify'
          }}>
            <p style={{ marginBottom: '20px' }}>
            Gaze-based navigation has emerged as a promising interaction technique in virtual reality (VR) environments, 
            offering hands-free control and intuitive user experience. However, the effectiveness of gaze-based navigation 
            across different path types remains largely unexplored. This study investigates the feasibility and performance 
            characteristics of gaze-based navigation when users traverse various path configurations including straight paths, 
            curved paths, and circular paths. We conducted a comprehensive user study with 24 participants to evaluate 
            navigation performance, accuracy, and user experience across these different path types. Our results demonstrate 
            that gaze-based navigation is most effective for straight paths, with performance gradually decreasing for curved 
            and circular paths. We also identify key factors that influence navigation success, including path complexity, 
            visual feedback mechanisms, and user adaptation patterns. These findings provide valuable insights for the design 
            of gaze-based navigation systems in VR applications, particularly for scenarios requiring complex spatial navigation.
            </p>
          
          </div>
        </div>

        {/* 按钮部分 */}
        <div style={{ marginBottom: '40px' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '20px',
            flexWrap: 'wrap'
          }}>
                         <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Code
             </button>
             
             <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Website
             </button>
             
             <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Paper
             </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AcademicPage_2_ISMAR;
